export default __webpack_public_path__ + "static/media/map.72dce20e.png";